class Kustomer {
    open() {
        try {
            return window.Kustomer.open();
        } catch (error) {
            console.log(error);
        }
    }
}

export default new Kustomer();
